import React from "react";

const ResortSidebar = ({ filters, setFilters }) => {
  const allAmenities = [
    "Airconditioner",
    "Festival",
    "Free Wifi",
    "Gym",
    "Mountain Bike",
    "Personal Guide",
    "Sightseeing",
    "Swimming Pool"
  ];

  // Toggleable radio button
  const handleRadioChange = (type, value) => {
    setFilters(prev => ({
      ...prev,
      [type]: prev[type] === value ? null : value, // toggle if same value clicked
    }));
  };

  // Toggleable price range
  const handlePriceChange = (range) => {
    setFilters(prev => {
      const isSelected =
        prev.priceRange?.[0] === range[0] &&
        prev.priceRange?.[1] === range[1];

      return {
        ...prev,
        priceRange: isSelected ? null : range, // toggle
      };
    });
  };

  // Handle amenities checkbox changes
  const handleAmenityChange = (amenityName) => {
    const updatedAmenities = filters.amenities?.includes(amenityName)
      ? filters.amenities.filter(a => a !== amenityName)
      : [...(filters.amenities || []), amenityName];

    setFilters(prev => ({ ...prev, amenities: updatedAmenities }));
  };

  return (
    <div className="resort-filter-box">
      {/* Price Filter */}
      <h3>Price Per Night</h3>
      {[[0, 2000], [2000, 4000], [4000, 6000], [6000, 8000]].map((range, i) => (
        <label key={i}>
          <input
            type="radio"
            name="price"
            checked={
              filters.priceRange?.[0] === range[0] &&
              filters.priceRange?.[1] === range[1]
            }
            onClick={() => handlePriceChange(range)} // toggle on click
            readOnly
          />
          <span>{range[0]} - {range[1]} /-</span>
        </label>
      ))}

      <hr />

      {/* Average Rating Filter */}
      <h3>Average Rating</h3>
      {[5, 4, 3, 2, 1].map(star => (
        <label key={star}>
          <input
            type="radio"
            name="rating"
            checked={filters.average_rating === star}
            onClick={() => handleRadioChange("average_rating", star)} // toggle on click
            readOnly
          />
          <span>{star}★ & Up</span>
        </label>
      ))}

      <hr />

      {/* Amenities Filter */}
      <h3>Amenities</h3>
      {allAmenities.map((amenity, i) => (
        <label key={i}>
          <input
            type="checkbox"
            checked={filters.amenities?.includes(amenity)}
            onChange={() => handleAmenityChange(amenity)}
          />
          <span>{amenity}</span>
        </label>
      ))}
    </div>
  );
};

export default ResortSidebar;
